import { InteractionType } from "@azure/msal-browser";
import { msalInstance } from "../index";
import { MSGraphUser } from "../models/MSGraphUser";
import { Client } from "@microsoft/microsoft-graph-client";
import { AuthCodeMSALBrowserAuthenticationProvider } from "@microsoft/microsoft-graph-client/authProviders/authCodeMsalBrowser";
import { IMSGraphService } from "../interfaces/IMSGraphService";

class MSGraphService implements IMSGraphService {

    private async getGraphClient(): Promise<Client> {
        const account = msalInstance.getActiveAccount();
        if (!account) {
            throw new Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
        }

        const authProvider = new AuthCodeMSALBrowserAuthenticationProvider(msalInstance, {
            account: account,
            interactionType: InteractionType.Silent,
            scopes: ['User.Read'],
        });


        return Client.initWithMiddleware({ authProvider: authProvider });

    }

    public async getGraphUserProfile(): Promise<MSGraphUser> {
        try {
            const client = await this.getGraphClient();
            const userData = await client.api('/me').get();
            return userData as MSGraphUser;
        } catch (error) {
            console.error('Failed to fetch Graph user profile:', error);
            return {
                id: '',
                displayName: '',
                givenName: '',
                surname: '',
                mail: '',
                userPrincipalName: '',
                jobTitle: '',
                mobilePhone: '',
                officeLocation: '',
                businessPhones: [],
                preferredLanguage: '',
            };
        }
    }


    public async getProfilePhoto(): Promise<any> {
        try {
            const client = await this.getGraphClient();
            const stream = await client.api('/me/photo/$value').get();
            return stream;

        } catch (error: any) {
            if (error.statusCode === 404) {
                console.warn("Profile photo not found.");
                return null; // or return a default image stream if you have one
            } else {
                console.error("Error fetching profile photo:", error);
                return null;
            }
        }
    }
}

export default MSGraphService;
